export default "__VITE_ASSET__44adbf13__$_?nuxt_component=async&nuxt_component_name=SvgoCross__"